import { Component, forwardRef } from '@angular/core';
import { JobListArgs, JobListArgsQuoteStatus } from 'src/shared/api';
import { FormConfig } from 'src/shared/form-models/form-cva.component';
import { slideUpSlideDown } from 'src/shared/animations';
import {
	NG_VALUE_ACCESSOR,
	ControlValueAccessor,
	FormBuilder,
	FormControl,
	FormGroup,
} from '@angular/forms';
import { displayQuoteStatus } from 'src/shared/enums';
import { buildArrayFromEnum } from 'src/shared/utilities/utility-functions';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { takeUntil } from 'rxjs/operators';
import { QuoteListFilters, makeDatesMoments } from '../quote-list.utility';

const quoteListFiltersFormConfig: FormConfig<QuoteListFilters> = {
	teamId: [''],
	customerId: [''],
	divisionId: [''],
	subdivisionId: [''],
	rwicId: [''],
	railroadId: [''],
	jobStatuses: [''],
	billingStatus: [''],
	payrollStatus: [''],
	quoteStatus: [''],
	startDate: new FormControl('', { updateOn: 'blur' }),
	endDate: [''],
	filterByApprovalDate: [''],
	searchText: [''],
};

@Component({
	selector: 'rpfsa-quote-list-filters',
	templateUrl: './quote-list-filters.component.html',
	animations: [slideUpSlideDown],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => QuoteListFiltersComponent),
			multi: true,
		},
	],
})
export class QuoteListFiltersComponent
	extends SelfDestruct
	implements ControlValueAccessor {
	readonly displayQuoteStatus = displayQuoteStatus;
	readonly quoteStatuses = buildArrayFromEnum(JobListArgsQuoteStatus);

	form = this.fb.group(quoteListFiltersFormConfig) as FormGroup;
	expanded = false;

	constructor(private readonly fb: FormBuilder) {
		super();
	}

	// model --> view
	writeValue(value: JobListArgs): void {
		if (value) {
			const filters = makeDatesMoments(value);
			this.form.reset(filters, { emitEvent: false });
		}
	}

	// view --> model
	registerOnChange(fn: (value: QuoteListFilters) => void) {
		this.form.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(fn);
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	onTouched: () => void = () => {};

	onKeyUpStartDate(key: string) {
		if (key === 'Backspace') {
			this.form.get('startDate').setValue('');
		}
	}

	clearFilters(): void {
		this.form.reset();
	}
}
